import { Skeleton } from "src/components"
import { selectCatalogRoofColorMessages } from "./selectCatalogRoofColor.messages"

export const SelectCatalogRoofColorSkeleton = () => (
	<Skeleton.Table
		caption="Select Catalog Roof Color List"
		headings={[selectCatalogRoofColorMessages.name, selectCatalogRoofColorMessages.code]}
		rows={6}
	/>
)
